import React, {Fragment, useEffect, useState} from 'react';
import {Empty, Spin} from "antd";
import {Area} from '@ant-design/plots';
import {LoadingOutlined} from "@ant-design/icons";
import {Content, LoadingWrapper, Root, Title, TitleWrapper} from "./styled";
import {useDashboardContext} from "contexts/DashboardProvider";
import {colors} from "utils/colors";

const config = {
  data: [],
  xField: 'month_year',
  yField: 'total',
  style: {
    fill: `linear-gradient(-90deg, #99bbff 0%, ${colors.primary} 100%)`,
  },
  axis: {
    y: { labelFormatter: '~s' },
  },
  line: {
    style: {
      stroke: null,
      strokeWidth: 0,
    },
  },
  tooltip: {
    title: 'month_year',
    items: ['Amount'],
  },
  shapeField: 'smooth',
};

const SalesChart = () => {

  const { state } = useDashboardContext()

  const [configData, setConfigData] = useState(config)

  useEffect(() => {
    setConfigData((prevState) => ({
      ...prevState,
      data: state.chart_sales
    }))
  }, [state.chart_sales])

  return (
    <Root>
      <TitleWrapper>
        <Title>Monthly Sales</Title>
      </TitleWrapper>
      <Content>
        {state.is_loading_chart_sales
          ? (
            <LoadingWrapper>
              <Spin indicator={<LoadingOutlined spin />} size={"large"} />
              <div>Fetching data ...</div>
            </LoadingWrapper>
          ) : (
            <Fragment>
              {state.chart_sales.length === 0
                ? <Empty description="No Data Available" />
                : <Area {...configData} />
              }
            </Fragment>
          )
        }
      </Content>
    </Root>
  )
}

export default SalesChart;
